import { render, staticRenderFns } from "./EmployeeLeaveSummaries.vue?vue&type=template&id=23c46dba&scoped=true"
import script from "./EmployeeLeaveSummaries.vue?vue&type=script&lang=js"
export * from "./EmployeeLeaveSummaries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c46dba",
  null
  
)

export default component.exports